<template>
    <div class="box">
        <!--<Modal v-model="upload_dialog" :title="$t('MaterialManagement.Material.uploadDialog.title')">
            &lt;!&ndash; <Uploader/> &ndash;&gt;
            <Uploader ref="uploader" :uploadServer="uploadServer" :categoryId="id">
                <div style="padding: 20px 0">
                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                    <p>{{ $t('MaterialManagement.Material.uploadDialog.prompt') }}</p>
                </div>
            </Uploader>
            <div slot="footer">
                <Button size="large" long @click="upload_dialog=false">{{ $t('Button.close') }}</Button>
            </div>
        </Modal>
        <Modal
            v-model="dialog"
            :title="$t('MaterialManagement.Material.editDialog.title')"
            :loading="dialog_loading"
            :mask-closable="false"
            @keydown.native.enter.prevent="save"
        >
            <Form :label-width="80">
                <FormItem :label="$t('MaterialManagement.Material.editDialog.name')" style="margin-bottom: 0">
                    <Input v-model="materialSettings.name" :maxlength="50"/>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="dialog=false">{{ $t('Button.cancel') }}</Button>
                <Button type="primary" size="large" @click="save">{{ $t('Button.confirm') }}</Button>
            </div>
        </Modal>
        <div class="header">
            <Row type="flex" class="toolbar">
                <Col span="24">
                    <Button
                        ref="upload_btn"
                        @click="showUploader"
                        icon="md-cloud-upload"
                        type="primary"
                    >{{ $t('MaterialManagement.Material.button.uploadMaterial') }}</Button>
                </Col>
            </Row>
            <div class="filter">
                <ul class="filter-box">
                    <li>
                        <span>{{ $t('MaterialManagement.Material.filter.name') }}</span>
                        <Input
                            class="selector"
                            v-model="filter.name"
                            size="small"
                            clearable
                            :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                    <li>
                        <span>{{ $t('MaterialManagement.Material.filter.type.title') }}</span>
                        <Select transfer class="selector" v-model="filter.type" size="small">
                            <Option :value="1">{{ $t('MaterialManagement.Material.filter.type.video') }}</Option>
                            <Option :value="2">{{ $t('MaterialManagement.Material.filter.type.audio') }}</Option>
                            <Option :value="3">{{ $t('MaterialManagement.Material.filter.type.image') }}</Option>
                        </Select>
                    </li>
                </ul>
            </div>
        </div>
        <Preview v-model="show_player" :material="playerMaterial" />
        <PicturePreviewDialog v-model="show_viewer" :imageSrc="viewerMaterial" />
        <div ref="list" class="content">

            <ul class="list">
                <li
                    class="item"
                    :key="p.id"
                    v-for="p in list"
                >
                    <div class="item-thumb">
                        <PrettyImage
                                :src="imgSrc(p)"
                        />
                        <div class="view" @click.stop="showPreview(p)">
                            <Icon
                                :type="p.type == Const.Material.Type.Image?'ios-search':'ios-play'"
                                class="view-icon"
                                size="24"
                            />
                        </div>
                    </div>

                    <div class="item-info">
                        <span class="title">
                            <span class="title-tag">
                                <PrettyText :text="Const.Material.Type(p.type)" />
                            </span>
                            <span :title="p.name">&nbsp;{{p.name}}</span>
                        </span>
                        <ul class="list">
                            <li>
                                <span class="title">{{ $t('MaterialManagement.Material.list.userName') }}</span>
                                <span class="content">
                                    {{p.userName}}
                                </span>
                            </li>
                            <li>
                                <span class="title">{{ $t('MaterialManagement.Material.list.topicName') }}</span>
                                <span class="content">
                                    {{ p.topicName }}
                                </span>
                            </li>
                            <li>
                                <span class="title">{{ $t('MaterialManagement.Material.list.status') }}</span>
                                <span class="content">
                                    <PrettyText :text="Const.Material.Status(p.status)" :type="p.type" />
                                    <span v-if="p.status == Const.Material.Status.Progress">- {{p.finishRate}}%</span>
                                </span>
                            </li>
                            <li v-if="globalConfig.mediaPublishFlag">
                                <span class="title">{{ $t('MaterialManagement.Material.list.publishStatus') }}</span>
                                <span v-if="p.type == 1" class="content">
                                    <PrettyText :text="Const.Material.PublishStatus(p.publishStatus)" />
                                </span>
                                <span v-else class="content">
                                    {{ $t('Message.explainEmpty') }}
                                </span>
                            </li>
                            <li>
                                <span class="title">{{ $t('MaterialManagement.Material.list.createDatetime') }}</span>
                                <span class="content">{{ p.createDatetime }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="item-op">
                        <Button
                            v-if="hasPermission('opMaterialInfo')"
                            class="download_btn"
                            type="text"
                            size="large"
                            icon="md-cloud-download"
                            style="margin-right: 5px"
                            @click="getDownload(p.id)"
                        >{{ $t('Button.download') }}</Button>
                        <Button
                                v-if="hasPermission('opMaterialInfo')"
                            class="edit_btn"
                            type="dashed"
                            size="large"
                            icon="md-settings"
                            @click="edit(p.id, p.name)"
                        >{{ $t('Button.edit') }}</Button>
                        <Button
                                v-if="hasPermission('opMaterialInfo')"
                            class="delete_btn"
                            type="dashed"
                            size="large"
                            icon="md-close"
                            @click="remove(p.id,p.name)"
                        >{{ $t('Button.remove') }}</Button>
                        <Button
                            v-if="hasPermission('opMaterialInfo') && globalConfig.mediaPublishFlag
                            && p.type == Const.Material.Type.Video &&  p.status == Const.Material.Status.Done"
                            :disabled="publishing(p.publishStatus)"
                            class="edit_btn"
                            type="dashed"
                            size="large"
                            icon="md-cloud-upload"
                            style="margin-left: 100px"
                            @click="publish(p.id, p.publishStatus)"
                        >{{ $t('Button.publish') }}</Button>
                    </div>
                </li>
            </ul>

            <Spin v-show="loading" fix class="spin">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Page
                class="pager"
                :total="pagination.total"
                :current="pagination.page"
                :page-size="pagination.pageSize"
                @on-change="v=>pagination.page=v"
                @on-page-size-change="v=>pagination.pageSize=v"
                show-elevator
                show-sizer
                transfer
            />
        </div>-->
        <Tabs @on-click="switchTab" :value="filter.type.toString()" :animated="false">
            <TabPane name="1" label="视频">
                <List v-if="filter.type == 1" :id="id" :topicUid="topicUid"></List>
            </TabPane>
            <TabPane name="2" label="音频">
                <List v-if="filter.type == 2" :id="id" :topicUid="topicUid"></List>
            </TabPane>
            <TabPane name="3" label="图片">
                <List v-if="filter.type == 3" :id="id" :topicUid="topicUid"></List>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import api from "@/api/Api";
import extend from "extend";
import List from './List';

export default {
    props: ['id','topicUid'],
    components: {
        List
    },
    data() {
        return {};
    },
    computed: {
        filter: {
            get() {
                return this.$store.state.views.material.all.filter;
            },
            set(v) {
                this.$store.commit("views/material.all.filter", v);
            }
        },
        pagination: {
            get() {
                return this.$store.state.views.material.all.pagination;
            },
            set(v) {
                this.$store.commit("views/material.all.pagination", v);
            }
        },
        ...mapState({

        })
    },
    watch: {

    },
    methods: {
        switchTab(name){
            this.filter.type = parseInt(name);
        }
    },
    mounted() {},
    created() {},
    beforeDestroy() {}
};
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .box {}
</style>